const ValidationSummary = ({ formState, containerId }) => {
    const errors = Object.keys(formState.fields || {})
        .map(key => formState.fields[key])
         .filter(field => 
             field.summaryError);

    if (errors.length === 0) return null;

    return (
        <div className="alert alert-danger" role="alert">
            <ul className="mb-0">
                {errors.map((field, index) => (
                    <li key={index}>{field.summaryError}</li>
                ))}
            </ul>
        </div>
    );
};

export default ValidationSummary;